module.exports = __webpack_public_path__ + "img/scene1.86e95938.svg";